import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShip: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="ship, changelog"><path d="M5.75 12.25V6.75H18.25V12.25M2.75 20.25L7.375 19.25L12 20.25L16.625 19.25L21.25 20.25M9.75 6.75V2.75H14.25V6.75M18.0908 19C19.4223 17.0859 19.94 15.4465 20.2222 13.25L12 11.25L3.77778 13.25C4.06005 15.4465 4.57773 17.0859 5.90918 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShip;
